import { toAnalyticsItems } from "~/sdk/ga4/transform/toAnalyticsItems"
import { getTotalValue } from "~/sdk/ga4/transform/getTotalValue"
import type { AnalyticsView, ProductItem } from "~/sdk/ga4/types/index"

export interface ToBeginCheckout {
    type?: 'begin_checkout'
    items: ProductItem[]
    view: AnalyticsView
    coupon?: string
}

export const toBeginCheckout = (data: ToBeginCheckout) => {
    const items = toAnalyticsItems({ items: data.items, view: data.view })
    const value = getTotalValue(items)

    return {
        name: 'begin_checkout' as const,
        params: {
            currency: data.items[0]?.extended?.currency ?? 'BRL',
            value,
            coupon: data.coupon ?? '',
            items,
        },
    }
}
